<div class="categories-table">
  @if (showFilter()) {
    <div class="row">
      <div class="col-12 accounts" fxLayout="row wrap" fxLayoutGap="15px" fxLayoutAlign="start center">
        @for (account of accounts; track account) {
          <mat-checkbox color="primary" [formControl]="accountFilter[account.id]" (change)="filterChangeHandler()">
            {{account?.accountHolder + "-" + account?.accountName + " (" + account?.bsbAccNumber + ")"}}
          </mat-checkbox>
        }
      </div>
    </div>
  }

  <div>
    @if (accountSelectionChanges && !singleAccount) {
      <div class="row">
        <div class="col-12"
          fxLayoutGap="10px"
          fxLayout="row"
          fxLayoutAlign="start center"
          fxLayout.lt-md="column"
          fxLayoutAlign.lt-md="center start">
          @if (!firstTimeLoadData) {
            <span class="text-primary">Account selection has been changed. Click to reload data</span>
          }
          @if (firstTimeLoadData) {
            <span class="text-primary">Click to load data</span>
          }
          <button class="reload-button arrow-left w-lt-md-100" (click)="onAccountSelect()">
            <span class="mdi mdi-refresh"></span>
          </button>
        </div>
      </div>
    }

    @if (dayEndBalanceChartData && dayEndBalanceChartData.length > 0) {
    <div class="row mt-3">
      <div class="col-12">
        <div>Day End Balance Chart for Selected Accounts</div>
        <day-end-balance-chart [data]="dayEndBalanceChartData" [index]="999" [lightTheme]="true"></day-end-balance-chart>
      </div>
    </div>
    }

    <div class="mt-3">
      <div class="col-12">
        <div>Monthly Debits / Credits for Selected Accounts</div>
        <monthly-debits-credits-chart [data]="selectedDebitCredit" [index]="999" [lightTheme]="true"></monthly-debits-credits-chart>
      </div>
    </div>
  </div>
</div>
